// DOM helpers shared by the form and popup renderers.
export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag)
  for (const [key, value] of Object.entries(attrs)) {
    if (value === null || value === undefined || value === false) continue
    if (key === 'text') node.textContent = value
    else if (key === 'class') node.className = value
    else if (key === 'html') node.innerHTML = value
    else node.setAttribute(key, value === true ? '' : value)
  }
  for (const child of [].concat(children)) if (child) node.append(child)
  return node
}

// A touch screen answers a focused field with its keyboard, so script-moved focus goes to a container there.
export function touchScreen() {
  try { return Boolean(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) } catch (error) { return false }
}

export function applyVariables(host, variables) {
  for (const [name, value] of Object.entries(variables || {})) host.style.setProperty(name, value)
}
